import { useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { PATH } from 'config/path';
import analytics from 'service/analytics';
import styles from './coupon-content.module.sass';
import { useInfiniteCoupons } from '../use-infinite-coupons';
import Tabs from 'componets/tabs';
import LoadingCard from 'componets/loading-card';
import { CouponList } from './coupon-list';

const TAB_OPTIONS = [
  { key: 'valid', value: '可使用' },
  { key: 'invalid', value: '已用畢或過期' },
];

export const CouponContent = () => {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const currentTabKey = searchParams.get('t') ?? TAB_OPTIONS[0].key;

  let couponState = [];

  switch (currentTabKey) {
    case 'valid':
      couponState = ['not_started', 'available'];
      break;
    case 'invalid':
      couponState = ['all_redeemed', 'expired'];
      break;
    default:
      break;
  }

  const { coupons, getCouponsStatus } = useInfiniteCoupons({
    state: couponState,
    perPage: 100,
  });

  const handleTabChange = useCallback(
    key => {
      if (key === 'valid') {
        analytics.couponPageValidTabClick();
      } else {
        analytics.couponPageInvalidTabClick();
      }
      history.push(`${PATH.COUPON}?t=${key}`);
    },
    [history]
  );

  return (
    <div className={styles['container']}>
      <Tabs list={TAB_OPTIONS} value={currentTabKey} onTabChange={handleTabChange} />
      {getCouponsStatus === 'loading' ? (
        <LoadingCard />
      ) : (
        <CouponList className={styles['coupon-list']} coupons={coupons} currentTabKey={currentTabKey} />
      )}
    </div>
  );
};
